<div class="cascading-filter-bar" role="group">
  @for (filter of viewModels; track filter.definition.key) {
    @if (filter.definition.control === 'checkbox') {
      <mat-checkbox
        class="cascading-filter-bar__checkbox"
        [checked]="isChecked(filter.selectedValue)"
        [disabled]="!filter.enabled || filter.definition.loading === true"
        (change)="onSelectionChanged(filter.definition.key, $event.checked)">
        {{ filter.definition.labelKey | translate }}
      </mat-checkbox>
    } @else {
      <mat-form-field appearance="outline" class="cascading-filter-bar__field">
        <mat-label>{{ filter.definition.labelKey | translate }}</mat-label>
        <mat-select
          [multiple]="filter.definition.multiple === true"
          [disabled]="!filter.enabled || filter.definition.loading === true"
          [value]="filter.selectedValue"
          (selectionChange)="onSelectionChanged(filter.definition.key, $event.value)">
          @if (filter.definition.multiple !== true) {
            <mat-option [value]="null">—</mat-option>
          }
          @for (option of filter.options; track option.value) {
            <mat-option [value]="option.value">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  }
</div>
